import { CommonModule } from '@angular/common';
import { Component, Input, WritableSignal, input } from '@angular/core';
import { AppBaseComponent } from "@app/shared/components/app-base.component";
import { UiLibraryModule } from '@template-ui/template-ui.module';
import { MatIcon } from "@angular/material/icon";

/**
 * A re-usable toggler that shows more or less depending on the state.
 * The state is set/retrieved via the showExpandedSignal.
 * TODO: Animate the toggle?
 */
@Component({
    selector: 'app-more-less-toggler',
    templateUrl: './more-less-toggler.component.html',
    styleUrl: './more-less-toggler.component.scss',
    imports: [
        CommonModule,
        UiLibraryModule,
        MatIcon
    ]
})
export class MoreLessTogglerComponent extends AppBaseComponent
{
  @Input({ required: true }) showExpandedSignal!: WritableSignal<boolean>;

  disabled = input<boolean>(false);
}
